import React from 'react';
import PropTypes from 'prop-types';
import pathfinder from '@fiverr-private/pathfinder';
import { translate } from '@fiverr-private/i18n-react';
import { HEADER_NAV_SOURCE } from '../../../../constants';
import Link from '../../../Links/Link';

const TeamAccountsLink = ({ teamSlug }) => {
    const link = teamSlug
        ? pathfinder(
              'team_member_dashboard_page',
              {
                  team_slug: teamSlug,
              },
              { query: { source: HEADER_NAV_SOURCE } }
          )
        : pathfinder(
              'seller_program_plans_page',
              { category: 'team_account' },
              { query: { source: HEADER_NAV_SOURCE } }
          );
    return (
        <Link href={link} rel="noopener noreferrer" className="nav-link" isNew>
            {translate('header.team_accounts')}
        </Link>
    );
};

export default TeamAccountsLink;

TeamAccountsLink.propTypes = {
    teamSlug: PropTypes.string,
};
